<template>
	<div class="container-fluid px-0">

		<div id="hero" class="bg-size-cover py-5" style="background: linear-gradient(to left, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)) 0% 0% / cover, url('https://i.picsum.photos/id/1076/2560/1440.jpg') center center no-repeat;">
		        <div class="container-fluid">

		        <div class="row no-gutters">
		            <div class="col-11 col-md-8 col-lg-6 col-xl-5 mx-auto">
		                <div class="d-flex flex-column justify-content-center text-center h-100">
							<h4 class="font-weight-light text-uppercase text-white mb-4">An Exclusive Online Live Event</h4>
							<div class="border-top border-2 border-bottom border-white">
		                    	<h1 class="text-white mb-0 py-3">LDJ +</h1>
		                    	<h1 class="text-white mb-0 py-3">Online Events Platform</h1>
	                    	</div>
	                    	<h4 class="font-weight-light text-white mt-4 mb-0">Hosted by LDJ Productions</h4>
		                </div>
		            </div>
		        </div>

		    </div>
		</div>

		<div id="event-details" class="row no-gutters">
			<div class="col-12 col-md-10 col-lg-9 col-xl-7 mx-auto">

				<div class="bg-white border-md border-light shadow-md-xl py-4">
					<div class="row no-gutters justify-content-center">
						<div class="col-10 col-md-8 col-lg-7">
							<div class="d-flex border border-md-2 border-light my-3 py-3">

								<div class="calendar d-flex flex-column shadow-lg ml-auto">
									<div class="bg-primary font-weight-semibold rounded-top small text-white text-center py-1">{{ $moment(datestart).format('MMM') }}</div>
									<div class="bg-white rounded-bottom py-1">
										<p class="font-bold h2 text-center my-1">{{ $moment(datestart).format('D') }}</p>
									</div>
								</div>

								<div class="d-flex flex-column pl-4 mr-auto">
									<p class="font-weight-bold leading-snug text-uppercase mb-0">{{ $moment(datestart).format('dddd') }}</p>
									<p class="font-weight-bold text-gray text-uppercase h4 mb-auto">{{ $moment(datestart).format('MMMM Do') }}</p>
									<p class="font-weight-bold text-uppercase mt-auto mb-0">{{ $moment(datestart).format('h:mm A') }} EST</p>
								</div>

					    	</div>
						</div>
					</div>
					<div class="row no-gutters justify-content-center">
						<div class="col-10 col-sm-6 col-md-8 col-lg-7">
						    <button type="button" class="btn btn-lg btn-primary btn-block my-4" @click="showModal">Register for Free</button>
						</div>
					</div>
					<div id="countdown" class="row no-gutters justify-content-center">
						<div class="col-12">
							<div class="d-flex flex-column mb-md-3">
								<countdown
									:starttime="eventStartsAt"
									:endtime="eventEndsAt"
									trans='{
									"day":"Days",
									"hours":"Hours",
									"minutes":"Minutes",
									"seconds":"Seconds",
									"expired":"Event has already passed",
									"running":"Event is ending in",
									"upcoming":"Event is starting in",
									"status": {
										"expired":"Expired",
										"running":"Running",
										"upcoming":"Upcoming"
									}}'
						    	/>

					    	</div>
						</div>
					</div>
				</div>

			</div>
		</div>

		<div class="row no-gutters">
			<div class="col-10 mx-auto">
				<h4 class="font-weight-light text-gray text-center mt-md-4">Share this event</h4>
				<div class="d-flex align-items-start justify-content-center pt-2 pt-md-4 pb-4">
					<a class="bg-facebook d-flex align-items-center justify-content-center lead rounded-circle text-decoration-none text-white mx-1 h-12 w-12" href="#">
						<i class="fab fa-facebook-f"></i>
					</a>
					<a class="bg-twitter d-flex align-items-center justify-content-center lead rounded-circle text-decoration-none text-white mx-1 h-12 w-12" href="#">
						<i class="fab fa-twitter"></i>
					</a>
					<a class="bg-linkedin d-flex align-items-center justify-content-center lead rounded-circle text-decoration-none text-white mx-1 h-12 w-12" href="#">
						<i class="fab fa-linkedin-in"></i>
					</a>
				</div>
			</div>
		</div>

  		<modal v-show="isModalVisible" @close="closeModal" /></modal>

	</div>
</template>

<script>
	import moment from 'moment';
	import Countdown from '../components/Countdown.vue';
	import Modal from '../components/Modal.vue';

	export default {
		components: {
			Countdown,
			Modal
		},
		props: {
			datestart: String,
			dateend: String
		},
		computed: {
			eventStartsAt: function() {
				return this.$moment(this.datestart).format('x');
			},
			eventEndsAt: function() {
				return this.$moment(this.dateend).format('x');
			},
		},
		methods: {
			showModal() {
				this.isModalVisible = true;
			},
			closeModal() {
				this.isModalVisible = false;
			}
		},
		data: function () {
			return {
				isModalVisible: false,
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/layouts/App.vue